<template>
  <div class="error">
    <div class="errorBox">
      <img class="errorImg" src="@/assets/error/404.png" alt="404" />
      <h2 class="title">该页面不存在</h2>
    </div>
  </div>
</template>
<script>
export default {
  name: "error",
  created() {
    setTimeout(() => {
      this.$router.push("/");
    }, 3000);
  },
};
</script>
<style lang="less" scoped>
.error {
  width: 100vw;
  height: 100vh;
  background: #7395ff;
  text-align: center;
  .errorBox {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: fit-content;
    height: fit-content;
    .errorImg {
      width: 100%;
      height: auto;
    }
    .title {
      text-align: center;
      line-height: 120px;
      font-size: 16px;
      color: #fff;
      letter-spacing: 4px;
    }
  }
}
</style>
